/**
 * Author: Stefan Haack (https://shaack.com)
 */
import {UiComponent} from "../../../lib/cm-web-modules/app/Component.js"
import {gameEventAction} from "../../chess-console-app/websocket/GambitWebSocketConnection.js"
import {COLOR} from "../../../lib/cm-chess/Chess.js"
import {get} from "svelte/store"
import {sessionData} from "../../stores.js"
import {consoleMessageTopics} from "../../../lib/chess-console/ChessConsole.js"

export class GameControls extends UiComponent {

    constructor(chessConsole, props) {
        super(chessConsole.componentContainers.controlButtons, props)
        this.chessConsole = chessConsole
        this.app = chessConsole.app
        this.dialogs = {
            resign: document.getElementById("resign-dialog"),
            acceptDraw: document.getElementById("accept-draw-dialog")
        }
        this.buttons = {
            resign: document.getElementById("button-resign"),
            drawOffer: document.getElementById("button-offer-draw"),
            acceptDraw: this.dialogs.acceptDraw.querySelector("button.yes")
        }
        /*
        this.buttons.resign.addEventListener("click", () => {
            sessionDataValue.showResignDialog = true
        })
         */
        this.buttons.drawOffer.addEventListener("click", () => {
            this.app.webSocketConnection.sendGameEvent(this.app.props.accessToken, gameEventAction.OFFER_DRAW)
        })
        this.i18n = chessConsole.i18n
        this.i18n.load({
            en: {
                "offer_draw": "offer draw",
                "resign": "resign",
                "abort": "abort",
                "accept_draw": "accept draw?",
                "yes": "yes",
                "no": "no"
            }
        }).then(() => {
            this.chessConsole.app.state.addObserver(() => {
                this.updateUIState()
            }, ["gameState"])
            this.updateUIState()
        })
    }
    updateUIState() {
        const sessionDataValue = get(sessionData)
        const gameState = this.chessConsole.app.state.gameState
        const firstMovesMade = gameState._pregameAbort.black.firstMoveMade && gameState._pregameAbort.white.firstMoveMade
        this.buttons.drawOffer.disabled = !firstMovesMade
        this.buttons.resign.disabled = !firstMovesMade
        if (this.chessConsole.props.playerColor === COLOR.white && gameState._drawState.black && !gameState._drawState.white ||
            this.chessConsole.props.playerColor === COLOR.black && gameState._drawState.white && !gameState._drawState.black) {
            sessionDataValue.showAcceptDrawDialog = true
            this.app.components.chessConsole.messageBroker.publish(consoleMessageTopics.drawOffer)
        } else {
            sessionDataValue.showAcceptDrawDialog = false
        }
        if (this.chessConsole.props.playerColor === COLOR.black && gameState._drawState.black && !gameState._drawState.white ||
            this.chessConsole.props.playerColor === COLOR.white && gameState._drawState.white && !gameState._drawState.black) {
            this.buttons.drawOffer.classList.add("active")
        } else {
            this.buttons.drawOffer.classList.remove("active")
        }
        sessionData.set(sessionDataValue)
    }
}
